require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
// import { vfmPlugin } from 'vue-final-modal'
// import { Modalable, ToModal } from "@alslimany/inertia-vue-modal-poc"
// import Modal from '@/Components/Modal';
import { mixin } from './mixins';
import { useModal } from './useModal';



// const launchMiddleware = require('launch-editor-middleware')



const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

import '@fortawesome/fontawesome-free/css/all.min.css';


// console.log(eventBus);

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => import(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        let _app = createApp({ render: () => h(app, props) })
            .use(plugin)
            // .use('/__open-in-editor', launchMiddleware())
            // .use(vfmPlugin)
            // .use(Modalable)
            // .use(ToModal)
            .component("InertiaLink", Link)
            // .component("Modal", Modal)
            .mixin(mixin)
            // .mixin(useModal)
            .mount(el);

        return _app;
    },
});

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 250,

    // The color of the progress bar.
    color: '#FFF',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: true,
});


// Helpers
require('./helpers');
